import { route as ziggyRoute } from 'ziggy-js';
import type { Config } from 'ziggy-js';

declare global {
  interface Window {
    Ziggy: Config;
  }
}

export function route(
  name: string,
  params?: Record<string, unknown> | unknown[] | unknown,
  absolute?: boolean,
): string {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return ziggyRoute(name, params as any, absolute, window.Ziggy);
}

export default route;
